import React, { Children, forwardRef } from 'react';
import { UIHeading4, UIText2, IconClose16 } from '@cian/ui-kit';
import cn from 'clsx';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var themeMap = {
  primary: {
    textColor: 'white_100',
    backgroundColor: 'var(--accent-primary-basic, #0468ff)'
  }
};
/**
 * Note: UI-kit компонент <Outside /> пробрасывает ref в дочерний компонент, поэтому тут нужен forwardRef
 */
export var SupportContactsWidgetPopup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onClose = _ref.onClose,
    description = _ref.description,
    children = _ref.children,
    heading = _ref.heading,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'primary' : _ref$theme;
  var colors = themeMap[theme];
  return /*#__PURE__*/_jsxs("section", {
    className: cn(styles.container, styles[theme]),
    style: {
      backgroundColor: colors.backgroundColor
    },
    role: "dialog",
    ref: ref,
    children: [heading && /*#__PURE__*/_jsx(UIHeading4, {
      as: "h2",
      color: colors.textColor,
      children: heading
    }), description && /*#__PURE__*/_jsx(UIText2, {
      as: "p",
      color: colors.textColor,
      children: description
    }), /*#__PURE__*/_jsx("ul", {
      className: styles.contacts_list,
      children: Children.map(children, function (element, index) {
        return /*#__PURE__*/_jsx("li", {
          children: element
        }, index);
      })
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
      className: styles.close_button,
      onClick: onClose,
      "data-testid": "support-contacts-widget-close-button",
      children: /*#__PURE__*/_jsx(IconClose16, {
        color: colors.textColor
      })
    })]
  });
});
SupportContactsWidgetPopup.displayName = 'SupportContactsWidgetPopup';